import { useEffect, useRef } from "react";
import ReactHtmlParser from "react-html-parser";

const ExamSkillsSection = ({
  title,
  highlight,
  subtitle,
  description,
  ctaText,
  onCtaClick,
  cards = [],
  bottomText,
  customStyle = false
}) => {
  const scrollRef = useRef(null);
   useEffect(() => {
      const slider = scrollRef.current;
      if (!slider) return;
      let isDown = false;
      let startX;
      let scrollLeft;
  
      const handleMouseDown = (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };
  
      const handleMouseLeave = () => {
        isDown = false;
        slider.classList.remove("active");
      };
  
      const handleMouseUp = () => {
        isDown = false;
        slider.classList.remove("active");
      };
  
      const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // scroll speed
        slider.scrollLeft = scrollLeft - walk;
      };
  
      // Touch support
      const handleTouchStart = (e) => {
        startX = e.touches[0].pageX;
        scrollLeft = slider.scrollLeft;
      };
  
      const handleTouchMove = (e) => {
        const x = e.touches[0].pageX;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      };
  
      slider.addEventListener("mousedown", handleMouseDown);
      slider.addEventListener("mouseleave", handleMouseLeave);
      slider.addEventListener("mouseup", handleMouseUp);
      slider.addEventListener("mousemove", handleMouseMove);
  
      slider.addEventListener("touchstart", handleTouchStart);
      slider.addEventListener("touchmove", handleTouchMove);
  
      return () => {
        slider.removeEventListener("mousedown", handleMouseDown);
        slider.removeEventListener("mouseleave", handleMouseLeave);
        slider.removeEventListener("mouseup", handleMouseUp);
        slider.removeEventListener("mousemove", handleMouseMove);
  
        slider.removeEventListener("touchstart", handleTouchStart);
        slider.removeEventListener("touchmove", handleTouchMove);
      };
    }, []);
  
  return (
    <section className="exam-section py-5">
      <div className="custom-container">
        {/* Top Row */}
        <div className="row align-items-center mb-5">
          {/* Left */}
          <div className="col-lg-6">
            <h2 className="top-section-text FS40FW600">
              {title} <span className="text-success">{highlight}{" "}</span>{" "+subtitle ? subtitle : "" }
            </h2>
          </div>

          {/* Right */}
          <div className="col-lg-6 text-start mt-3 mt-lg-0">
            {description && 
                <p className="text-muted FS16FW500 fw-300 mb-3">
                {typeof description === "string"
                    ? ReactHtmlParser(description)
                    : description}
                </p>
            }

            <button className="primary-btn" onClick={onCtaClick}>
              {ctaText}{" "}<img src={`/images/web-new-images/right-arrow.svg`} alt="LA"/>
            </button>
          </div>
        </div>

        {/* Cards */}
        <div className={`row  g-4  ${customStyle ? "flex-nowrap overflow-auto scroll-row" : ""}`} ref={scrollRef}>
          {cards.map((card, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <SkillCard card={card} />
            </div>
          ))}
        </div>

        {/* Bottom Text */}
        <p className="text-center mt-5 text-muted">
            {bottomText && bottomText}
        </p>
      </div>
    </section>
  );
};

export default ExamSkillsSection;

const SkillCard = ({ card }) => {
  return (
    <div className="skill-card h-100 p-4">
      {/* Icon + Title */}
      <div className="d-flex align-items-center mb-3">
        <div className="me-3">
          <img src={card.icon} alt="icon" />
        </div>
        <h6 className="mb-0 plus-sans FS24FW500 to-unset-transform">{card.title}</h6>
      </div>

      {/* Content */}
      <div className="text-muted small">
        {typeof card.content === "string" ? ReactHtmlParser(card.content) : card.content}
      </div>
    </div>
  );
};
